import { jsx } from "react/jsx-runtime";
import { forwardRef } from "react";
import { f as faCircleExports } from "../../../_virtual/faCircle.es.js";
import { f as faXmarkExports } from "../../../_virtual/faXmark.es.js";
import { Chip, Stack } from "@mui/material";
import EzIcon from "../../EzIcon/EzIcon.es.js";
const STATUS_MAP = {
  neutral: { color: "neutral", icon: false },
  success: { color: "success", icon: false },
  informational: { color: "info", icon: false },
  attention: { color: "info", icon: true },
  warning: { color: "common.orange110", icon: true },
  error: { color: "error", icon: true },
  alert: { color: "alert", icon: true }
};
const EzChipMui = forwardRef(
  ({ color, icon, size, variant, ...props }, ref) => {
    const isCommonColor = color == null ? void 0 : color.startsWith("common.");
    const isStatus = Object.keys(STATUS_MAP).includes(variant);
    const chipThemeColor = isStatus ? STATUS_MAP[variant].color : isCommonColor ? void 0 : color;
    const chipCommonColor = isCommonColor ? color : void 0;
    const chipColor = chipThemeColor || chipCommonColor;
    const chipFontColor = variant === "outlined" ? chipColor : void 0;
    const DotIcon = /* @__PURE__ */ jsx(Stack, { sx: { fontSize: "6px !important" }, children: /* @__PURE__ */ jsx(EzIcon, { icon: faCircleExports.faCircle, color: chipColor, size: "inherit" }) });
    const DeleteIcon = /* @__PURE__ */ jsx(Stack, { sx: { fontSize: "12px" }, "data-testid": "DeleteIcon", children: /* @__PURE__ */ jsx(EzIcon, { icon: faXmarkExports.faXmark, color: "inherit", size: "inherit" }) });
    return /* @__PURE__ */ jsx(
      Chip,
      {
        ref,
        classes: {
          root: `EzChip EzChip-${variant}`,
          clickable: "EzChip-clickable",
          deletable: "EzChip-deletable",
          deleteIcon: "EzChip-deleteIcon",
          disabled: "EzChip-disabled",
          icon: "EzChip-icon",
          label: "EzChip-label"
        },
        color: isStatus ? void 0 : chipThemeColor,
        deleteIcon: DeleteIcon,
        icon: isStatus ? STATUS_MAP[variant].icon ? DotIcon : void 0 : icon,
        size: size === "inherit" ? void 0 : size,
        sx: {
          bgcolor: variant === "filled" ? chipCommonColor : void 0,
          borderColor: variant === "outlined" && isCommonColor ? color : void 0,
          color: chipFontColor,
          fontSize: size === "inherit" ? "inherit" : void 0,
          "&.EzChip-warning": { color: "common.orange110" }
        },
        variant: variant === "outlined" ? variant : void 0,
        ...props
      }
    );
  }
);
EzChipMui.displayName = "EzChipMui";
export {
  EzChipMui as default
};
//# sourceMappingURL=EzChipMui.es.js.map
